// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607090634/js/" + chunkId + "." + {"44":"4ddeabf7","225":"396b9721","481":"745cbba4","486":"a125de33","770":"148924c5"}[chunkId] + ".0.12310727867153781.chunk.js";
};